import React, { useContext, useEffect } from "react";
import {
  IonButtons,
  IonHeader,
  IonToolbar,
  IonPage,
  IonContent,
  IonBackButton,
  IonButton,
  IonIcon,
  IonTitle,
} from "@ionic/react";

import "./providers.css";
import Header from "../../components/Header/Header";
import { addCircle, arrowBackCircleSharp } from "ionicons/icons";
import ProvidersComponent from "../../components/ProvidersComponent";
import * as Helper from "../../services/Helpers";
import { ApplicationContext } from "../../ApplicationState";
import { useTranslations } from "../../hooks/useTranslations";

const Providers: React.FC = (props: any) => {
  const { userState, setUserState } = useContext(ApplicationContext);
  const [userAttributes, setUserAttributes] = React.useState<any | undefined>(
    {}
  );
  const labels = useTranslations()

  useEffect(() => {
    let user = userState.authenticatedUser;
    let attr = Helper.getUserAttributes(
      user.signInUserSession["idToken"].jwtToken
    );
    setUserAttributes(attr);
  }, [userState]);

  return (
    <IonPage>
      <Header />
      <IonHeader>
        <IonToolbar color="light">
          <IonButtons slot="start">
            <IonBackButton
              text={labels.Goback}
              icon={arrowBackCircleSharp}
              defaultHref="/"
            />

          </IonButtons>
          <IonTitle>
            {labels.Providers}
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <ProvidersComponent type="" />
      </IonContent>
    </IonPage>
  );
};

export default Providers;
